import React, { useEffect } from "react";
import { useState } from "react";
import compose from "recompose/compose";
import { batch, connect } from "react-redux";
import { withRouter } from "react-router-dom";
import moment from "moment";
import Filter from "./components/Filter";
import Table from "./components/Table";
import { db } from "firebase/client";
import { reportSelections } from "../reportSelections";
import Datetime from "react-datetime";

// mui
import { Button, Card, Dialog, Hidden, InputAdornment, TextField, Typography } from "@material-ui/core";

// components
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";

// styling
import Style from "assets/jss/material-dashboard-pro-react/views/reportsStyle";
import withStyles from "@material-ui/core/styles/withStyles";

import { ptsFormula } from "globalCalculationFunction/globalCalculationFunction";
import Loader from "components/Loader/Loader";

// icons
import { ReactComponent as CalendarIcon } from "assets/img/tuzo/icons/calendarIconWhite.svg";
import { Cancel, CheckCircle } from "@material-ui/icons";

const headers = [
  { label: "Merchant #", key: "merchantNumber" },
  { label: "Merchant Name", key: "name" },
  { label: "Date", key: "reportDate" },
  { label: "Points Earned", key: "pointsEarned" },
  { label: "Day Total", key: "dayTotal" },
  { label: "", key: "action" },
];

const csvHeaders = [
  { label: "Merchant #", key: "merchantNumber" },
  { label: "Merchant Name", key: "name" },
  { label: "Quantity", key: "quantity" },
  { label: "Points Earned", key: "pointsEarned" },
  { label: "Day Total", key: "dayTotal" },
  { label: "Date", key: "reportDate" },
  { label: "Basis Points", key: "userBasisPts" },
];

const filterArr = [
  "All",
  "Current Month",
  "Last Week",
  "Last Month",
  "Custom Range"
]

export function SalesByMerchant(props) {
  const mid = window.location.pathname.split("/")[5]
  const { classes, history, userType } = props;
  const [reportArr, setReportArr] = useState([]);
  const [sortValue, setSortValue] = useState("");
  const [filterValue, setFilterValue] = useState("Current Month")
  const [reportType, setReportType] = useState("Sales by Merchant");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const itemsPerPage = 9;
  const [pageNumber, setPageNumber] = useState(0);
  const [index, setIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(itemsPerPage);
  const [data, setData] = useState(false);
  const [batchInfoArr, setBatchInfoArr] = useState(false);
  const [copyArr, setCopyArr] = useState([]);
  const [points, setPoints] = useState([]);
  const [searchString, setSearchString] = useState("");
  const [rangeModal, setRangeModal] = useState("")
  const [errors, setErrors] = useState({
    fromDate: false,
    toDate: false
  })

  const tomorrow = moment().add(0, "day");
  const disableFutureDt = (current) => {
    return current.isBefore(tomorrow);
  };

  const disableFromDt = (current) => {
    return current.isAfter(fromDate);
  };

  const numberFormatterDecimals = new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const numberFormatter = new Intl.NumberFormat("en-US", {});

  const handlePageClick = ({ selected }) => {
    setPageNumber(selected);
    setIndex(selected * itemsPerPage);
    setEndIndex(selected * itemsPerPage + itemsPerPage);
  };

  const handleFilterReport = (batchInfo, value) => {
    if (value === "All") {
      batchInfo.sort(
        (a, b) =>
          new Date(b.reportDate).getTime() - new Date(a.reportDate).getTime()
      );
      setBatchInfoArr(batchInfo)
    }
    else if (value === "Current Month") {
      let currentMonth = moment().month() + "" + moment().year()
      const filter = batchInfo.filter((data) => {
        let formattedDate = moment(data.reportDate).month() + "" + moment(data.reportDate).year()
        
        if (formattedDate === currentMonth) {
          return true
        }
      })
      filter.sort(
        (a, b) =>
          new Date(b.reportDate).getTime() - new Date(a.reportDate).getTime()
      );
      setBatchInfoArr(filter)
    }
    else if (value === "Last Week") {
      let startOfLastWeek = moment().startOf('week').subtract(7, 'days')
      let endOfLastWeek = moment().endOf('week').subtract(7, 'days')
      const filter = batchInfo.filter((data) => {
        if(moment(data.reportDate).isBetween(startOfLastWeek, endOfLastWeek, 'days', [])){
          return true
        }
      })
      filter.sort(
        (a, b) =>
          new Date(b.reportDate).getTime() - new Date(a.reportDate).getTime()
      );
      setBatchInfoArr(filter)
    }
    else if (value === "Last Month") {
      let lastMonth = (moment().month() - 1) + "" + moment().year()
      const filter = batchInfo.filter((data) => {
        let formattedDate = moment(data.reportDate).month() + "" + moment(data.reportDate).year()
        if (formattedDate === lastMonth) {
          return true
        }
      })
      filter.sort(
        (a, b) =>
          new Date(b.reportDate).getTime() - new Date(a.reportDate).getTime()
      );
      setBatchInfoArr(filter)
    }
    else if (value === "Custom Range") {
      setRangeModal(true)
    }
    else {
      const filter = batchInfo.filter((data) => {
        if(moment(data.reportDate).isBetween(moment(fromDate), moment(toDate), 'days', [])){
          return true
        }
      })
      filter.sort(
        (a, b) =>
          new Date(b.reportDate).getTime() - new Date(a.reportDate).getTime()
      );
      setBatchInfoArr(filter)
      setFromDate("")
      setToDate("")
    }
    setIndex(0)
    setEndIndex(itemsPerPage)
    setPageNumber(0)
    setData(true)
  }

  const resetDateRangeModal = () => {
    handleFilterReport(copyArr, "Current Month")
    setFilterValue("Current Month")
    setFromDate("")
    setToDate("")
    setRangeModal(false)
  }

  const handleSearch = () => {
    if (searchString) {
      const filtered = copyArr.filter((f) => {
        if (f.merchantName.toLowerCase().includes(searchString.toLowerCase())) {
          return true;
        }
        if (
          f.merchantNumber.toLowerCase().includes(searchString.toLowerCase())
        ) {
          return true;
        }
      });
      setBatchInfoArr(filtered);
    } else {
      setBatchInfoArr(copyArr);
    }
  };

  useEffect(() => {
    reportSelections.map((data) => {
      if (data.type === "Admin" && userType.includes("Admin")) {
        setReportArr((prevArr) => [...prevArr, data]);
      }
    });
  }, []);

  const getData = () => {
    let merchantData = {};
    let docArr = [];

    return db
      .collection("users")
      .where("merchantId", "==", mid)
      .get()
      .then(async (snapshots) => {
        if (!snapshots.empty) {
          snapshots.forEach((s) => {
            s = s.data();
            merchantData = s
          });
        } else {
          setData([]);
        }
        db.collection("merchants-live")
          .where("merchantNumber", "==", mid)
          .get()
          .then((snapshots) => {
            if (!snapshots.empty) {
              snapshots.forEach((doc) => {
                db.collection('merchants-live')
                  .doc(doc.data().docId)
                  .collection("batch-summary")
                  .get()
                  .then((subSnapshot) => {
                    if (!subSnapshot.empty) {
                      subSnapshot.forEach((subDoc) => {
                        subDoc = subDoc.data()
                        let pointsEarned = ptsFormula(subDoc.netAmount, merchantData.userBasisPts)
                        let merchantName = merchantData.companyName
                        let email = merchantData.email;
                        let userBasisPts = merchantData.userBasisPts;
                        let newObj = {
                          ...subDoc,
                          merchantName,
                          email,
                          parentDocId: doc.data().docId,
                          userBasisPts,
                          pointsEarned
                        };
                        docArr.push(newObj);
                      })
                      setCopyArr(docArr)
                      handleFilterReport(docArr, filterValue)
                    }
                    else {
                      setCopyArr([])
                      setBatchInfoArr([])
                    }
                  })
              })
            }
          })
      })
  };

  useEffect(() => {
    if (!data) {
      getData();
    }
  }, []);

  if (!data || !batchInfoArr) return <Loader />;

  return (
    <div>
      <Hidden mdUp implementation="css">
        <div>
          <Typography
            variant="h2"
            className={classes.title}
            style={{ color: "#1A405F" }}
          >
            Please View Page on Desktop / Laptop
          </Typography>
        </div>
      </Hidden>

      <Hidden smDown implementation="css">
        <GridContainer>
          <GridItem xs={12}>
            <Typography variant="h2" className={classes.title}>
              Reports
            </Typography>
          </GridItem>

          <GridItem xs={12} style={{ marginTop: "20px" }}>
            <Card style={{ padding: "25px 20px 5px" }}>
              <GridContainer>
                <GridItem xs={12}>
                  <Filter
                    reportSelections={reportArr}
                    sortValue={sortValue}
                    setSortValue={setSortValue}
                    batchInfoArr={batchInfoArr}
                    copyArr={copyArr}
                    headers={csvHeaders}
                    numberFormatterDecimals={numberFormatterDecimals}
                    numberFormatter={numberFormatter}
                    searchString={searchString}
                    setSearchString={setSearchString}
                    handleSearch={handleSearch}
                    filterArr={filterArr}
                    filterValue={filterValue}
                    setFilterValue={setFilterValue}
                    handleFilterReport={handleFilterReport}
                    setData={setData}
                  />
                </GridItem>

                <GridItem xs={12}>
                  <Table
                    history={history}
                    data={batchInfoArr}
                    pageNumber={pageNumber}
                    setPageNumber={setPageNumber}
                    index={index}
                    setIndex={setIndex}
                    endIndex={endIndex}
                    setEndIndex={setEndIndex}
                    itemsPerPage={itemsPerPage}
                    handlePageClick={handlePageClick}
                    headers={headers}
                    points={points}
                    setPoints={setPoints}
                    numberFormatterDecimals={numberFormatterDecimals}
                    numberFormatter={numberFormatter}
                  />
                </GridItem>
              </GridContainer>
            </Card>
          </GridItem>
        </GridContainer>
      </Hidden>

      <Dialog
        classes={{
          paper: classes.dateRangeModal
        }}
        open={rangeModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xl"
      >
        <Card className={classes.modalCard}>
          <GridContainer>
            <GridItem xs={12} style={{ display: "flex", justifyContent: "space-evenly" }}>
              <h5 className={classes.cardHeaderModal}>Select Range of Dates</h5>
            </GridItem>

            <GridItem xs={6} className={classes.gridItemMarginTop}>
              <Typography
                style={errors.fromDate ? { marginTop: "30px" } : {}}
                className={classes.modalCardDesc}>
                From
              </Typography>
            </GridItem>

            <GridItem xs={6} className={classes.gridItemMarginTop}>
              <div>
                {errors.fromDate ? (
                  <span className={classes.errText}> Please fill out the field</span>
                ) : null}
                <Datetime
                  isValidDate={disableFutureDt}
                  className='travel'
                  selected={fromDate}
                  dateFormat="MM/DD/YY"
                  onChange={(date, e) => {
                    setFromDate(date.format("MM/DD/YY"));
                  }}
                  timeFormat={false}
                  closeOnSelect={true}
                  closeOnClickOutside
                  renderInput={(props, openCalendar, closeCalendar) => (
                    <div onClick={openCalendar}>
                      <TextField
                        style={{ width: "100%" }}
                        className={classes.datetimeModal}
                        value={fromDate}
                        variant="outlined"
                        InputProps={{
                          classes: {
                            adornedEnd: classes.adournedEndModal,
                            input: classes.input
                          },
                          endAdornment: (
                            <InputAdornment
                              className={classes.adournedEndModal}
                              position="end"
                            >
                              <Button className={classes.datetimeButtonModal}>
                                <CalendarIcon
                                  className={classes.calendarIcon}
                                  onClick={openCalendar}
                                />
                              </Button>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </div>
                  )}
                />
              </div>
            </GridItem>

            <GridItem xs={6} className={classes.gridItemMarginTop}>
              <Typography
                style={errors.toDate ? { marginTop: "30px" } : {}}
                className={classes.modalCardDesc}>
                To
              </Typography>
            </GridItem>

            <GridItem xs={6} className={classes.gridItemMarginTop}>
              <div>
                {errors.toDate ? (
                  <span className={classes.errText}> Please fill out the field</span>
                ) : null}
                <Datetime
                  isValidDate={disableFromDt}
                  className='travel'
                  selected={toDate}
                  dateFormat="MM/DD/YY"
                  onChange={(date, e) => {
                    setToDate(date.format("MM/DD/YY"));
                  }}
                  timeFormat={false}
                  closeOnSelect={true}
                  closeOnClickOutside
                  renderInput={(props, openCalendar, closeCalendar) => (
                    <div onClick={openCalendar}>
                      <TextField
                        style={{ width: "100%" }}
                        className={classes.datetimeModal}
                        value={toDate}
                        variant="outlined"
                        InputProps={{
                          classes: {
                            adornedEnd: classes.adournedEndModal,
                            input: classes.input
                          },
                          endAdornment: (
                            <InputAdornment
                              className={classes.adournedEndModal}
                              position="end"
                            >
                              <Button className={classes.datetimeButtonModal}>
                                <CalendarIcon
                                  className={classes.calendarIcon}
                                  onClick={openCalendar}
                                />
                              </Button>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </div>
                  )}
                />
              </div>
            </GridItem>

            <GridItem xs={12} style={{ display: "flex", justifyContent: "space-evenly", marginTop: "15px" }}>
              <Button
                onClick={() => resetDateRangeModal()}
                className={classes.modalButton}>
                <Cancel style={{ marginRight: "10px", marginTop: "-5px" }} /> Cancel
              </Button>
              <Button
                onClick={() => {
                  handleFilterReport(copyArr, "Filter")
                  setRangeModal(false)
                }}
                className={classes.modalButton}
                style={{ background: "#1A405F", }}>
                <CheckCircle style={{ marginRight: "10px", marginTop: "-5px" }} /> Filter
              </Button>
            </GridItem>
          </GridContainer>
        </Card>
      </Dialog>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    userId: state.auth.user.uid,
    userType: state.auth.user.userType,
    user: state.auth.user,
    userCompany: state.auth.user.companyName,
  };
}

function mapDispatchToProps(actions) {
  return (dispatch) => ({});
}

export default withRouter(
  compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(Style)
  )(SalesByMerchant)
);
